module.exports = __webpack_public_path__ + "img/down_actif.c7dd348a.png";